module.exports = __webpack_public_path__ + "assets/img/checked3-42ff18c9.png";